import React, { useState } from "react";
import { useInvitation } from "../contexts/InvitationContext";
import { useTheme } from "../contexts/ThemeContext";

const InvitationCode: React.FC = () => {
  const [code, setCode] = useState("");
  const { validateCode, loading, error } = useInvitation();
  const { getColor } = useTheme();

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    if (code.trim()) {
      await validateCode(code.trim());
    }
  };

  return (
    <div className="invitation-code-container">
      <div className="code-header">
        <p>
          Please enter the code from your wedding invitation
        </p>
      </div>

      <form onSubmit={handleSubmit} className="code-form">
        <div className="form-group">
          <label htmlFor="invitation-code">Invitation Code</label>
          <input
            type="text"
            id="invitation-code"
            value={code}
            onChange={(e) => setCode(e.target.value.toUpperCase())}
            placeholder="Enter your code (e.g., ABC123)"
            maxLength={10}
            required
            className="code-input"
            style={{
              borderColor: "#8b8e8b",
              backgroundColor: "rgba(255, 255, 255, 0.05)",
              color: "#d3d6d3",
            }}
          />
        </div>

        {error && <div className="error-message">{error}</div>}

        <button
          type="submit"
          disabled={loading || !code.trim()}
          className="submit-btn"
          style={{
            backgroundColor:
              loading || !code.trim()
                ? getColor("gray")
                : getColor("forestGreen"),
            color: "white",
          }}
        >
          {loading ? "Validating..." : "Enter Registry"}
        </button>
      </form>
    </div>
  );
};

export default InvitationCode;
